// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('FavoriteArticleVO')
export class FavoriteArticleVO {
  @JsonProperty('articleId', 'Number')
  public articleId: number = undefined;

  @JsonProperty('articleNumber', 'String')
  public articleNumber: string = undefined;

  @JsonProperty('sortOrder', 'Number')
  public sortOrder: number = undefined;

  @JsonProperty('displayName', 'String')
  public displayName: string = undefined;
}

@JsonObject('FavoriteArticlesWrapperVO')
export class FavoriteArticlesWrapperVO {

  @JsonProperty('articleTypeId', 'Number')
  public articleTypeId: number = undefined;

  @JsonProperty('isWireBridgeArticles', 'Boolean')
  public isWireBridgeArticles: boolean = undefined;

  @JsonProperty('favoriteArticles', '[FavoriteArticleVO]')
  public favoriteArticles: FavoriteArticleVO[] = [];
}
